import { useTranslation } from "react-i18next";

export default function FooterSection() {
  const { t } = useTranslation();

  return (
    <footer className="relative bg-[#030508] border-t border-white/5 py-12">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-10">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-rocket-2-fill text-amber-400 text-2xl" />
            </div>
            <span className="text-white font-bold text-xl tracking-[0.3em] uppercase" style={{ fontFamily: "'Orbitron', sans-serif" }}>
              ARTEMIDA
            </span>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-6 text-xs text-white/30 tracking-widest uppercase">
            <a href="#timeline" className="hover:text-amber-400 transition-colors cursor-pointer">{t("nav_timeline")}</a>
            <a href="#invest" className="hover:text-amber-400 transition-colors cursor-pointer">{t("nav_invest")}</a>
            <a href="#technology" className="hover:text-amber-400 transition-colors cursor-pointer">{t("nav_technology")}</a>
            <a href="#roadmap" className="hover:text-amber-400 transition-colors cursor-pointer">{t("nav_roadmap")}</a>
          </div>
          <div className="flex items-center gap-3">
            {[
              { icon: "ri-twitter-x-line", label: "Twitter" },
              { icon: "ri-linkedin-line", label: "LinkedIn" },
              { icon: "ri-telegram-line", label: "Telegram" },
              { icon: "ri-discord-line", label: "Discord" },
            ].map((s) => (
              <a key={s.label} href="#" aria-label={s.label} className="w-8 h-8 flex items-center justify-center border border-white/10 rounded-sm text-white/30 hover:text-amber-400 hover:border-amber-400/30 transition-all cursor-pointer">
                <i className={`${s.icon} text-sm`} />
              </a>
            ))}
          </div>
        </div>
        <div className="h-px bg-white/5 mb-8" />
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/20 text-xs tracking-widest uppercase text-center md:text-left">{t("footer_tagline")}</p>
          <p className="text-white/20 text-xs">{t("footer_rights")}</p>
        </div>
        <p className="mt-6 text-white/10 text-xs text-center leading-relaxed max-w-3xl mx-auto">{t("footer_disclaimer")}</p>
      </div>
    </footer>
  );
}
